(function() {
    'use strict';

    angular.module('order').controller('OrderProductSourceFileModalController', OrderProductSourceFileModalController);

    OrderProductSourceFileModalController.$inject = [
        '$uibModalInstance',
        'orderProduct',
        'notificationSrvc',
        'errorNotificationSrvc',
        'sourceFileDataSrvc'
    ];

    function OrderProductSourceFileModalController(
        $uibModalInstance, orderProduct, notificationSrvc, errorNotificationSrvc, sourceFileDataSrvc
    ) {
        var self = this;

        self.orderProduct = orderProduct;

        self.closeModal = closeModal;
        self.submitForm = submitForm;
        self.cleanErrors = cleanErrors;

        self.serverErrors = {
            file: []
        }

        self.modelData = {
            file: null,
        };

        function submitForm(){
            self.requestData = {
                order_product: self.orderProduct.pk,
                file: self.modelData.file
            };

            sourceFileDataSrvc.create(self.requestData).$promise.then(
                function (response) {
                    self.modelData.file = null;
                    notificationSrvc.notification(
                        'success', 'Dodano plik zródłowy do pozycji zamówienia ' + self.orderProduct.pk);
                    $uibModalInstance.close(self.orderProduct);
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            )
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
